export function cleanEmail(email) {
  return String(email)
    .replace(/\s/g, "")
    .replace(/[^a-zA-Z0-9@._+-]/g, "");
}
